import {
    Dialog,
    DialogTitle,
    DialogContent,
    Stack,
    Typography, IconButton,
} from "@mui/material";
import { FaFileDownload } from 'react-icons/fa';
import CloseIcon from '@mui/icons-material/Close';
import ImprimirPDF from "./ImprimirPdf";
import ImprimirExcel from "./ImprimirExcel";

const ModalInformes = ({ open, onClose, informes = [], empresa }) => {
    return (
        <Dialog open={open} onClose={onClose} fullWidth maxWidth="md">
            <DialogTitle
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    paddingRight: 2, // espacio a la derecha para el botón
                }}
            >
                <Typography variant="h6">
                <FaFileDownload size={18} />Informes Disponibles</Typography>

                <IconButton
                    onClick={onClose}
                    color="danger"
                    size="small"
                    sx={{ ml: 2 }}
                >
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent dividers>
                {informes.map((info, index) => (
                    <div key={index} style={{ marginBottom: "2rem" }}>
                        <Typography variant="h6" gutterBottom>{info.title}</Typography>
                        <Stack direction="row" spacing={2}>
                            {(info.tipo === "both" || info.tipo === "solopdf") && (
                                <ImprimirPDF
                                    headers={info.headers}
                                    rows={info.rows}
                                    filters={info.filters}
                                    titlePdf={info.title}
                                    empresa={empresa}
                                />
                            )}

                            {(info.tipo === "both" || info.tipo === "soloexcel") && (
                                <ImprimirExcel
                                    headers={info.headers}
                                    rows={info.rows}
                                    filters={info.filters}
                                    titlePdf={info.title}
                                    empresa={empresa}
                                />
                            )}
                        </Stack>
                    </div>
                ))}
            </DialogContent>

        </Dialog>
    );
};

export default ModalInformes;
